<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">港 詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="save" v-permit.SHARP_PORT_NEW>{{
          $t("app.buttons.save")
        }}</v-btn>
        <v-btn @click="$router.go(-1)">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
      <v-form ref="form" v-model="valid">
        <v-container fluid>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :rules="[
                  (v) =>
                    !!v || 'HSCD' + this.$t('app.validator.messages.required'),
                ]"
                :disabled="isEdit"
                clearable
                label="HSCD"
                required
                v-model.trim="form.code"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="名称"
                required
                v-model="form.name"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="英語名称"
                required
                v-model="form.englishName"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <v-text-field
                :disabled="isEdit"
                clearable
                label="SC側CD"
                v-model="form.scCode"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="所在地"
                url="countries/kv"
                v-model="form.countryCode"
              ></remote-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <v-select
                :items="[
                  { text: 'IMPORT', value: 'IMPORT' },
                  { text: 'EXPORT', value: 'EXPORT' },
                ]"
                clearable
                item-text="text"
                item-value="value"
                label="进出口区分"
                v-model="form.tradeType"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <v-text-field
              v-if="form.tradeType === 'IMPORT' "
                clearable
                label="国code（JusFin用）"
                v-model="form.jusdaCountryCode"
                :rules="[(v) => !!v || 'mapping国家2字码 is required']"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      valid: true,
      form: {
        name: null,
      },
      nameRules: [(v) => !!v || "Name is required"],
      errors: {
        CODE_EXISTS: "当該CDは既に存在しています。",
      },
    };
  },
  computed: {
    isEdit() {
      return false;
    },
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) return;
      this.$http
        .post("/ports", this.form)
        .then(() => {
          this.$router.go(-1);
        })
        .catch((err) => {
          this.$showError(err);
        });
    },
  },
};
</script>
